import cn from "classnames"

import { Psychologist } from "utils/interfaces"
import style from "modules/PsyCommon/components/PsychologistTitles/style.module.scss"
import { psychologistTitles } from "utils/helpers/psychologistUtil"
import { capitalize } from "utils/utils"

export function PsychologistTitles({ psy, className }: { psy: Psychologist; className?: string }) {
    const profileTitles = psychologistTitles(psy)
    const titles = profileTitles.map((title) => <div key={title}>{capitalize(title)}</div>)
    return <span className={cn(style.container, className)}>{titles}</span>
}
